import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextEditor } from '../../ui/TextEditor';

interface Props {
  disabled?: boolean;
}

export const PropertyDetailsTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <TextEditor
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.propertydetails.fields.propertyDescription.label')}
      fieldName="descriptions.propertyDetails"
    />
  );
};
